/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type { TypeAsset } from '/stores/AssetStore';

import { ComponentWithInjectedProps } from 'utils/injectedProps';
import Loading from 'components/Loading/Loading';
import Form from 'forms/_.extend';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';
import UnassignAssetForm from './UnassignAssetForm/UnassignAssetForm';
import UnassignAssetSuccess from './UnassignAssetSuccess/UnassignAssetSuccess';
import UnassignAssetError from './UnassignAssetError/UnassignAssetError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  formData: Object,
};

type InjectedProps = {
  actionDrawerStore: TypeActionDrawerStore,
  assetStore: TypeAsset,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'assetStore')
@observer
export default class UnassignUserFromAsset extends ComponentWithInjectedProps<
  TypeProps,
  {},
  InjectedProps
> {
  createForm = () => {
    const { t, actionDrawerStore, assetStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const fields: Array<Object> = [
      {
        name: 'unassignAsset',
        label: t('general:actions.unassign_asset'),
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        if (!(asset && asset.account)) {
          assetStore.clearDetails();
          assetStore.loadAsset(asset.id);
        }
      },
      onSuccess(data: Object) {
        actionDrawerStore.unassignUserFromAsset(asset.id);
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'unassignAsset',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.unassign_asset');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <UnassignAssetError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <UnassignAssetSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <UnassignAssetForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
